import { z } from "zod";

export const repoBranchSubmoduleSchema = z
  .object({ name: z.string(), path: z.string(), url: z.string() })
  .strict();

export const repoBranchSubmodulesSchema = z.array(repoBranchSubmoduleSchema);

export type RepoBranchSubmodule = z.infer<typeof repoBranchSubmoduleSchema>;
